import React from "react";
import Format from "../../../../Utils/formatCurrent";
import FormatDate from "../../../../Utils/formatDate";
import "./styles.scss";
const CardParcela = ({ index, parcela }) => {
  return (
    <div
      key={index}
      className="centralized-column parcelasAPagar cardParcelas mobile-card"
      style={{ boxShadow: "0px 0px 8px #003da5" }}
    >
      <div className="centralized-space-between cardParcelas__detalhesVisiveis pacelasPagas">
        <div className="centralized pacelasPagas__item__descricaoParcela">
          <div className="centralized-column">
            <span>Descricao da parcela:</span>
            <span>
              {parcela.descricaoParcela}
            </span>
          </div>
        </div>
        <div className="centralized pacelasPagas__item__valores">
          <div className="centralized-column">
            <div className="centralized-space-between">
              <span>Valor principal: </span>
              <span>{Format(parcela.totPrinc)}</span>
            </div>
            <div className="centralized-space-between">
              <span>Valor pago: </span>
              <span>{Format(parcela.vlParcelaPaga)}</span>
            </div>
          </div>
        </div>
        <div className="centralized pacelasPagas__item__datas">
          <div className="centralized-column">
            <div className="centralized-space-between">
              <span>Vencimento: </span>
              <span>{FormatDate(parcela.vencimento)}</span>
            </div>
            <div className="centralized-space-between">
              <span>Pago em: </span>
              <span>{FormatDate(parcela.dataRecebido)}</span>
            </div>
          </div>
        </div>
        <div className="centralized pacelasPagas__item__numParcela">
          <div className="centralized-column">
            <div className="centralized">
              <span>Numero da parcela: {parcela.numeroParcela}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardParcela;
